import React, { MouseEventHandler, ReactNode } from 'react';
import { styles } from './CarouselLeadBrand.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { ProductCarousel, ProductCarouselProps } from '../ProductCarousel/ProductCarousel';
import { useTrackingContext } from '../Tracking';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';

export type CarouselLeadBrandProps = {
  brandImage?: ReactNode;
  linkProps?: GoToLinkProps;
  ctaButton?: ReactNode;
  heading: string;
  subText?: string;
  isWhiteSubText?: boolean;
  productCarouselProps: ProductCarouselProps;
};

export const CarouselLeadBrand = ({
  brandImage,
  heading,
  subText,
  isWhiteSubText,
  productCarouselProps,
  linkProps,
  ctaButton,
}: CarouselLeadBrandProps) => {
  const { tracker } = useTrackingContext();
  if (!tracker.isEmpty) {
    tracker.group = heading ?? tracker.group;
  }

  const handleCtaClick: MouseEventHandler<HTMLAnchorElement> = e => {
    tracker.trackClick({ label: linkProps?.label, extraData: { moduleName: 'Carousel lead brand CTA' } });
    linkProps?.onClick?.(e);
  };
  return (
    <div className={styles.wrapper}>
      {linkProps ? <GoToLink {...linkProps} className={styles.link} onClick={handleCtaClick} /> : null}
      <div className={styles.container}>
        <div className={styles.leadContainer}>
          {brandImage ? <div className={styles.brandImage}>{brandImage}</div> : null}
          <DomFont className={styles.heading} as="h2">
            {heading}
          </DomFont>
          {subText ? <p className={styles.subText({ isWhiteSubText })}>{subText}</p> : null}
          {ctaButton ? <div className={styles.calloutBtnDesktop}>{ctaButton}</div> : undefined}
        </div>
        <div className={styles.carouselContainer}>
          <ProductCarousel {...productCarouselProps} />
        </div>
      </div>
      {ctaButton ? <div className={styles.calloutBtn}>{ctaButton}</div> : undefined}
    </div>
  );
};
